module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aJkjw"))).then(() => parcelRequire('2KbAe'));